import styled from 'styled-components';
import { mediaBreakpointDown } from 'styles/grid';

export const ItemContainer = styled.div<{
  isDropdownItem?: boolean;
  isLastItem: boolean;
  isActive: boolean;
  isClickable: boolean;
  as?: 'button' | 'div';
}>`
  min-width: 0;
  gap: 8px;
  padding: ${({ as }) => {
    return as === 'button' ? '8px 12px' : '4px 12px';
  }};

  display: flex;
  flex: 1 1 0%;
  align-items: center;
  height: 52px;
  font-family: inherit;
  background-color: ${({ theme, isDropdownItem }) =>
    isDropdownItem ? 'inherit' : theme.configs.tertiaryBox.bgColor};
  border-radius: ${({ isDropdownItem }) => (isDropdownItem ? '0px' : '4px')};
  border: ${({ isActive, isDropdownItem, theme }) => {
    return !isDropdownItem
      ? `3px solid ${
          isActive
            ? theme.configs.CTAButton.bgColor
            : theme.configs.tertiaryBox.secondaryFontColor
        }`
      : 'none';
  }};
  
  cursor: ${({ isClickable }) => {
    return isClickable ? 'pointer' : 'default';
  }};

  margin-bottom: ${({ isDropdownItem }) => {
    return isDropdownItem ? '0px' : '8px';
  }};

  margin-right: ${({ isLastItem, isDropdownItem }) => {
    return isLastItem || isDropdownItem ? '0px' : '16px';
  }}};

  &:hover {
    background-color: ${({ isDropdownItem }) => {
      return isDropdownItem && '#e5f1ff';
    }};
  }

  ${mediaBreakpointDown.sm} {
  padding: ${({ isActive }) => isActive && '0px'};
    height: ${({ isActive }) => isActive && 'auto'};
    margin-bottom: ${({ isActive }) => isActive && '0px'};
    &:hover {
      background-color: ${({ isActive }) => isActive && 'unset'};
    }
  }
`;

export const ItemProgress = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  flex: 1;
  gap: 4px;
`;

export const ItemNumber = styled.div<{
  isActive: boolean;
  isDropdownItem?: boolean;
}>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
  color: ${({ theme, isActive }) => {
    if (isActive) return theme.configs.tertiaryBox.mainFontColor;
    return theme.configs.tertiaryBox.secondaryFontColor;
  }};
  font-weight: ${({ isDropdownItem, isActive }) =>
    isDropdownItem || isActive ? 'bold' : 'normal'};

  ${mediaBreakpointDown.sm} {
    color: ${({ theme, isActive }) => {
      if (isActive) return theme.configs.tertiaryBox.mainFontColor;
      return theme.configs.mainBox.fontColor;
    }};
  }
`;

export const ItemNumberWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`;

export const ItemLabelType = styled.div`
  display: inline-block;
  width: fit-content;
  height: fit-content;
  padding: 2px 8px;
  font-size: 10px;
  border-radius: 100px;
  font-weight: normal;
  flex: none;
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  background-color: ${({ theme }) => theme.configs.mainBox.bgColor};
  border: 1px solid ${({ theme }) => theme.configs.mainBox.bgColor};
`;

export const ItemLabel = styled.div<{
  labelFontSize: number;
  isDropdownItem: boolean;
  isActive: boolean;
}>`
  font-size: ${({ labelFontSize }) => labelFontSize}px;
  color: ${({ theme, isDropdownItem, isActive }) => {
    return isDropdownItem || !isActive
      ? theme.configs.tertiaryBox.secondaryFontColor
      : theme.configs.tertiaryBox.mainFontColor;
  }};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${mediaBreakpointDown.sm} {
    color: ${({ theme, isDropdownItem, isActive }) => {
      if (isDropdownItem && isActive)
        return theme.configs.tertiaryBox.mainFontColor;
      return theme.configs.tertiaryBox.secondaryFontColor;
    }};
  }
`;

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;

  // for custom icons
  svg {
    width: 24px;
    height: 24px;
  }
`;
